import Rails from "@rails/ujs";

$(function() {
  function setInputName(column, partnerCount) {
    return [
      'register_form[partner_params][' + (partnerCount - 1) + '][' + column + ']',
      'register_form[partner_params][' + partnerCount + '][' + column + ']'
    ];
  }

  function setInputId(column, partnerCount) {
    return [
      'register_form_partner_params_' + (partnerCount - 1) + '_' + column,
      'register_form_partner_params_' + partnerCount + '_' + column
    ];
  }

  function resetValue(addForm, element) {
    $(element).val('');
  }

  function updateNameAttributes(addForm, name, partnerCount) {
    let [beforeInputName, afterInputName] = setInputName(name, partnerCount);
    addForm.find('[name="' + beforeInputName + '"]').each(function(index, element) {
      $(element).attr('name', afterInputName);
    });
  }

  function updateIdAttributes(addForm, name, partnerCount, resetFlag) {
    let [beforeInputId, afterInputId] = setInputId(name, partnerCount);
    addForm.find('#' + beforeInputId).each(function(index, element) {
      $(element).attr('id', afterInputId);
      if(resetFlag) { resetValue(addForm, element) }
    });
  }

  function reviewDeleteButton() {
    let partnerCount = $('.partner_section').length;
    let deleteButton = $('#delete_partner_form');

    if(partnerCount > 1) {
      if(deleteButton.length) {
        deleteButton.text(partnerCount + '頭目を削除');
      } else {
        $('#partner_form_button').prepend('<div class="button-wrap__item"><button name="button" type="button" class="button-secondary" id="delete_partner_form">' + partnerCount + '頭目を削除</button></div>');
        deletePartnerAction();
      }
    } else {
      deleteButton.remove();
    }
  }

  function defineApplyAuthCode() {
    $('#apply-auth-code-btn').off('click');
    $('#apply-auth-code-btn').on('click', function() {
      var form_data = new FormData();
      form_data.append("auth_code", $("#apply_auth_code").val());
      Rails.ajax({
        type: "post",
        url: "/register/apply_auth_code",
        data: form_data,
        dataType: "script",
      });
    });
  }
  defineApplyAuthCode();

  $('#add_partner_form').on('click', function() {
    let lastPartnerSection = $('.partner_section:last');
    let addForm = lastPartnerSection.clone();
    let partnerCount = $('.partner_section').length;

    $.each(['name', 'name_kana', 'sex_male', 'sex_female', 'birthday_year', 'birthday_month', 'birthday_day', 'dog_kind_id', 'pet_kind_type'], function(index, name) {
      let resetFlag = !['sex_male', 'sex_female'].includes(name);
      updateIdAttributes(addForm, name, partnerCount, resetFlag);
      updateNameAttributes(addForm, name, partnerCount);
    });
    updateNameAttributes(addForm, 'sex', partnerCount);
    addForm.find('.partner_number').text(partnerCount + 1 + '頭目');
    addForm.find('input[type="radio"]:checked').prop('checked', false);
    addForm.find('select.pet_kind_type').val('');
    addForm.find('select.dog_kind_id').attr('disabled', true);
    addForm.find('select.dog_kind_id').parent().hide();
    addForm.find('.form-error-message').remove();

    lastPartnerSection.after(addForm);
    reviewDeleteButton();
  });

  function deletePartnerAction() {
    $('#delete_partner_form').on('click', function() {
      $('.partner_section:last').remove();
      reviewDeleteButton();
    });
  }
  deletePartnerAction();

  $('#register-back').on('click', function(e) {
    e.preventDefault();
    $(this).parents("form").attr("action", "/register/new");
    $(this).parents("form").submit();
  });

  $('body').on('change', '.pet_kind_type', function(e) {
    let petKindType = $(this).val();
    let targetPublicKinds = [];
    let targetKinds = [];
    switch (petKindType) {
      case 'dog':
        targetKinds = selectDogKinds;
        targetPublicKinds = selectPublicDogKinds;
        break;
      case 'cat':
        targetKinds = selectCatKinds;
        targetPublicKinds = selectPublicCatKinds;
    }
    let $petKindDivSelect = $(this).closest('.select').next();
    $petKindDivSelect.find('option').remove();
    $petKindDivSelect.find('optgroup').remove();

    if (petKindType === 'other' || petKindType === '') {
      $petKindDivSelect.hide();
      $petKindDivSelect.children('select').attr('disabled', true);
    } else {
      $petKindDivSelect.show();
      $petKindDivSelect.children('select').removeAttr('disabled');
    }

    let $petKindSelect = $petKindDivSelect.children('select');
    if (targetKinds.length > 0) {
      let kindType = { 'dog': '犬種', 'cat': '猫種' }
      $(`<option style="display: none;" value>${kindType[petKindType]}を選択してください</option>`).appendTo($petKindSelect);
    }
    if (targetPublicKinds.length > 0) {
      let kindType = { 'dog': '犬種', 'cat': '猫種' }
      let label = `よく選ばれる${kindType[petKindType]}`;
      let optgroup = $('<optgroup>', { label: label });
      $.each(targetPublicKinds, function(index, kind) {
        optgroup.append($(`<option value="${kind[1]}">${kind[0]}</option>`));
      });
      $petKindSelect.append(optgroup);
    }
    let optgroup = $('<optgroup>', { label: "あいうえお順" });
    $.each(targetKinds, function(index, kind) {
      optgroup.append($(`<option value="${kind[1]}">${kind[0]}</option>`));
    });
    $petKindSelect.append(optgroup);
  });

  function validateFuriganaInput() {
    const nameFields = ['input[name="register_form[last_name]"]', 'input[name="register_form[first_name]"]'];
    const furiganaFields = ['input[name="register_form[last_name_kana]"]', 'input[name="register_form[first_name_kana]"]'];
    const $furiganaMessageField = $('#furigana_block');

    const isNameEntered = nameFields.some(selector => {
      const $field = $(selector);
      return $field.length > 0 && $field.val().trim() !== '';
    });

    let showMessage = false;

    furiganaFields.forEach((selector) => {
      const $furiganaField = $(selector);

      if ($furiganaField.length > 0) {
        if (isNameEntered && $furiganaField.val().trim() === '') {
          $furiganaField.addClass('is-error');
          showMessage = true;
        } else {
          $furiganaField.removeClass('is-error');
        }
      }
    });

    const $message = $furiganaMessageField.next('.furigana-message');
    if (showMessage) {
      if ($message.length === 0) {
        $furiganaMessageField.after('<div class="furigana-message" style="color: red; margin-top: 5px;">名前（フリガナ）を入力してください。</div>');
      }
    } else {
      $message.remove();
    }
  }

  $('input[name="register_form[last_name]"], input[name="register_form[first_name]"], input[name="register_form[last_name_kana]"], input[name="register_form[first_name_kana]"]').on('input', validateFuriganaInput);

  validateFuriganaInput();
});
